import React from "react";

const STATUS_MAP = {
  pendente: { label: "Pendente", classes: "bg-amber-50 text-amber-800 border-amber-200" },
  aguardando_aprovacao: { label: "Aguardando Aprovacao", classes: "bg-amber-50 text-amber-700 border-amber-200" },
  aprovada: { label: "Aprovada", classes: "bg-blue-50 text-blue-800 border-blue-200" },
  contrato_enviado: { label: "Contrato Enviado", classes: "bg-violet-50 text-violet-800 border-violet-200" },
  assinada: { label: "Assinada", classes: "bg-indigo-50 text-indigo-800 border-indigo-200" },
  liquidando: { label: "PIX em Processamento", classes: "bg-cyan-50 text-cyan-800 border-cyan-200" },
  liquidada: { label: "Liquidada", classes: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  aguardando: { label: "Aguardando Liberacao", classes: "bg-orange-50 text-orange-800 border-orange-200" },
  vencida: { label: "Vencida", classes: "bg-red-100 text-red-900 border-red-300" },
  recusada: { label: "Recusada", classes: "bg-red-50 text-red-800 border-red-200" },
  cancelada: { label: "Cancelada", classes: "bg-zinc-100 text-zinc-700 border-zinc-200" },
  // Traduções do lifecycle da V2 sem equivalente local (proxy normalizado —
  // v2_proxy._V2_LIFECYCLE_TO_LOCAL: EXPIRED/CONTRACT_ERROR/PAYMENT_ERROR)
  expirada: { label: "Expirada", classes: "bg-zinc-100 text-zinc-700 border-zinc-200" },
  erro_contrato: { label: "Erro no Contrato", classes: "bg-red-50 text-red-800 border-red-200" },
  erro_pagamento: { label: "Erro no Pagamento", classes: "bg-red-50 text-red-800 border-red-200" },
  active: { label: "Ativo", classes: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  inactive: { label: "Inativo", classes: "bg-zinc-100 text-zinc-700 border-zinc-200" },
  pending: { label: "Pendente", classes: "bg-amber-50 text-amber-800 border-amber-200" },
  approved: { label: "Aprovado", classes: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  rejected: { label: "Rejeitado", classes: "bg-red-50 text-red-800 border-red-200" },
  cancelled: { label: "Cancelado", classes: "bg-zinc-100 text-zinc-700 border-zinc-200" },
};

export default function StatusBadge({ status }) {
  const info = STATUS_MAP[status] || { label: status, classes: "bg-zinc-100 text-zinc-700 border-zinc-200" };
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-semibold border ${info.classes}`}
      data-testid={`status-badge-${status}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70"></span>
      {info.label}
    </span>
  );
}
